'use client';
import { useIsClient } from 'usehooks-ts';
import { TelegramProductShortResponseDto } from '@/generated';
import { ProductViewCarouselClient } from './client';

type ProductCarouselProps = {
  similarProducts: TelegramProductShortResponseDto[];
};

export const ProductViewCarousel = ({ similarProducts }: ProductCarouselProps) => {
  const mounted = useIsClient();
  // Wait until the browser hydrates the component to avoid SSR/CSR markup mismatches.
  if (!mounted) {
    return null;
  }
  return (
    <div className=' md:mt-[28px] mt-[16px] lg:mt-[40px]'>
      <ProductViewCarouselClient similarProducts={similarProducts} />
    </div>
  );
};
